import CalendarComponent from "../../components/calendar/CalendarComponent";
import React from 'react';
import { useParams } from 'react-router-dom';

export default function ViewCalendarPage() {
    const { view, day, year, month } = useParams<{view:string, day:string, year:string, month:string}>();

    if (!view || !day || !year || !month) return null;

    // Convert 1-based month from URL to 0-based for JS Date/Component
    const monthInt = Number.parseInt(month) - 1;

    return (
      <CalendarComponent view={view} day={day} month={monthInt.toString()} year={year}/>
    );
}